/**
 * News selectors
 */

import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectNews = (state: any) => state.news || initialState;

const makeSelectNews =
  createSelector(
    selectNews,
    newsState => newsState.news,
);

const makeSelectNewsItem =
  createSelector(
    selectNews,
    newsState => newsState.newsItem,
);

const makeSelectLoading =
  createSelector(
    selectNews,
    newsState => newsState.loading,
);

const makeSelectLoadingButton =
  createSelector(
    selectNews,
    newsState => newsState.loadingButton,
);

const makeSelectNewsPage = createSelector(
  selectNews,
  newsState => newsState.page,
);

const makeSelectMostReadNewsByCategory = 
  createSelector(
    selectNews,
    newsState => newsState.news
);

const makeSelectPageCount = createSelector(
  selectNews,
  newsState => newsState.pageCount,
)

const makeSelectCurrentPage = createSelector(
  selectNews,
  newsState => newsState.currentPage,
);

const makeSelectSuccesModal = createSelector(
  selectNews,
  newsState => newsState.modal.success,
);

const makeSelectPageMostReadNewsCount = createSelector(
  selectNews,
  newsState => newsState.pageMostReadNewsCount,
)

const makeSelectCurrentMostReadNewsPage = createSelector(
  selectNews,
  newsState => newsState.currentMostReadNewsPage,
);

const makeSelectLoaderMostReadNews = createSelector(
  selectNews,
  newsState => newsState.loaderMostReadNews,
);

const makeSelectNewsItemError = createSelector(
  selectNews,
  newsState => newsState.error,
);

const makeSelectMostReadNews = createSelector(
  selectNews,
  newsState => newsState.mostReadNews,
);


export {
  makeSelectNews,
  makeSelectNewsItem,
  makeSelectLoading,
  makeSelectNewsPage,
  makeSelectMostReadNewsByCategory,
  makeSelectSuccesModal,
  makeSelectCurrentPage,
  makeSelectPageCount,
  makeSelectLoadingButton,
  makeSelectPageMostReadNewsCount,
  makeSelectCurrentMostReadNewsPage,
  makeSelectLoaderMostReadNews,
  makeSelectNewsItemError,
  makeSelectMostReadNews
 };
